import React from "react";
import "./header.css";
import CTA from "./CTA";
import ME from "../../assets/VikiLogo2.png";
import HeaderSocials from "./HeaderSocials";
const Header = () => {
  return (
    <header>
      <div className="container header__container">
        <h5>Bienvenido a</h5>
        <h1>Beauty Planner</h1>
        <h5 className="text-light">de Victoria Guajardo</h5>
        <CTA />
        <HeaderSocials />

        <a href="#contact" className="scroll__down">
          Scroll Down
        </a>
        <div className="me">
          <img src={ME} alt="me" />
        </div>
      </div>
    </header>
  );
};

export default Header;
